// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__d69lf","buttonContainer":"Footer_buttonContainer__H_96s","inactive":"Footer_inactive__OSAmH"};